// extracted by mini-css-extract-plugin
export default {"info":"styles_info__sT2w2","info__icon":"styles_info__icon__NQa7E","info__content":"styles_info__content__FWLxc"};